import React from 'react';
import WhyChooseUs from './WhyChooseUs';

const Services = () => {
  return (
    <div>
      <WhyChooseUs/>
      <h1></h1>
    </div>
  );
};

export default Services;
